import React from 'react';

interface LineLoginIconProps {
  size?: number;
  color?: string;
}

export const LineLoginIcon: React.FC<LineLoginIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="2" />
      <path
        d="M20 19C20 17.985 20 17.4776 19.8278 17.0646C19.44 16.1349 18.4395 15.4073 17.1611 15.1253C16.5933 15 15.8956 15 14.5 15H9.5C8.10444 15 7.40665 15 6.83886 15.1253C5.56045 15.4073 4.56004 16.1349 4.17224 17.0646C4 17.4776 4 17.985 4 19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
